import { jsxs, jsx } from "react/jsx-runtime";
import * as React from "react";
import { cx } from "../internal/cx.js";
import { useFieldControl } from "./Field.js";
const Switch = React.forwardRef(function Switch2({ children, className, style, onChange, onCheckedChange, ...props }, ref) {
  const { disabled, ...rest } = useFieldControl(props);
  const handleChange = (event) => {
    onChange?.(event);
    onCheckedChange?.(event.currentTarget.checked, event);
  };
  return /* @__PURE__ */ jsxs("label", { className: cx("ev-switch", className), style, "data-disabled": disabled ? "true" : void 0, children: [
    /* @__PURE__ */ jsx("input", { ref, role: "switch", disabled, onChange: handleChange, ...rest, type: "checkbox" }),
    /* @__PURE__ */ jsx("span", { className: "ev-switch__track", "aria-hidden": "true" }),
    children != null && children !== false ? /* @__PURE__ */ jsx("span", { className: "ev-switch__label", children }) : null
  ] });
});
Switch.displayName = "Switch";
export {
  Switch
};
//# sourceMappingURL=Switch.js.map
